// extracted by mini-css-extract-plugin
export default {"page":"NV","headerwrap":"OV","headerblock":"PV","textwrapper":"QV","text":"RV","closerlook":"SV","arrowwrap":"TV","icon":"UV","updown":"VV","products":"WV","system":"XV","systemimage":"YV","cards":"ZV","note":"aW","fadein":"bW"};
    if(module.hot) {
      // 1721922365838
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  